/**
 * Click2Buy "Scroll to retailer list" anchor: scroll to #click2buy-inline.
 * Uses event delegation so it works when content is injected after load.
 */
(function() {
  const HEADER_FALLBACK_OFFSET = 80;
  const SCROLL_MARGIN_ADJUSTMENT = 32;
  const RESIZE_EVENT_DELAY = 800;

  document.addEventListener('click', function(e) {
    const link = e.target.closest && e.target.closest('a[href="#click2buy-inline"]');
    if (!link) return;

    e.preventDefault();

    const target = document.getElementById('click2buy-inline') ||
      document.querySelector('[data-inline-container-auto-open]');
    if (!target) return;

    const header = document.querySelector('store-header, .header');
    const headerOffset = header ? header.getBoundingClientRect().height : HEADER_FALLBACK_OFFSET;
    let sectionHeaderHeight = 0;
    const prev = target.previousElementSibling;
    if (prev) sectionHeaderHeight = prev.getBoundingClientRect().height || 0;

    target.style.scrollMarginTop = (headerOffset + sectionHeaderHeight + SCROLL_MARGIN_ADJUSTMENT) + 'px';
    target.scrollIntoView({ behavior: 'instant', block: 'start' });
  });

  // Click2Buy's third-party widget/iframe doesn't always calculate its
  // height correctly on initial load. Triggering a resize nudges it to
  // recalculate. No public API available for this.
  window.addEventListener('load', function() {
    setTimeout(function() {
      window.dispatchEvent(new Event('resize'));
    }, RESIZE_EVENT_DELAY);
  });
})();
